module.exports = __webpack_public_path__ + "static/media/indust.3df652c5.jpg";